import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0221e880")
const _hoisted_1 = { class: "justify-center mt-5 d-flex align-center width-full" }
const _hoisted_2 = { class: "width-full app-bar-content d-flex align-center" }
_popScopeId()

import { IChannel } from '@/interfaces/hoppermation'
import { PropType, withDefaults } from 'vue'
import CreateAutomationDialog from './Dialog/CreateAutomationDialog.vue'

interface IProps {
  channels?: PropType<IChannel[]>
}


export default /*#__PURE__*/_defineComponent({
  props: {
    channels: { type: null, required: false, default: () => [] }
  },
  setup(__props: any) {

const props = __props as { channels: PropType<IChannel[]> }


return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { absolute: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_app_bar_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('navigation.automations')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(CreateAutomationDialog, {
            channels: props.channels
          }, null, 8, ["channels"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})